export default __webpack_public_path__ + "static/site-image-b5453cc8b1bc42d41da2061f813fea65.jpg";